import { render, staticRenderFns } from "./remittancepayable.vue?vue&type=template&id=0553c2a4&scoped=true&"
import script from "./remittancepayable.vue?vue&type=script&lang=js&"
export * from "./remittancepayable.vue?vue&type=script&lang=js&"
import style0 from "./remittancepayable.vue?vue&type=style&index=0&id=0553c2a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0553c2a4",
  null
  
)

export default component.exports